import { useEffect, useState } from 'react';

import { getStrategyBenchmarks } from '../services/cmsService';

const useStrategyBenchmarks = strategy => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [benchmarks, setBenchmarks] = useState(null);

  useEffect(() => {
    if (!strategy) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await getStrategyBenchmarks(strategy);
        if (cancelled) return;
        setBenchmarks(data);
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load strategy benchmarks');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [strategy]);

  return { loading, error, benchmarks };
};

export default useStrategyBenchmarks;
